// Configuration EmailJS
// Remplacez ces valeurs par vos vraies clés depuis votre tableau de bord EmailJS

export const emailjsConfig = {
  // Votre Service ID (ex: 'service_abc123')
  serviceId: 'service_9exeibk',
  
  // Votre Template ID (ex: 'template_xyz789')
  templateId: 'template_ctnd77h',
  
  // Votre Public Key (ex: 'user_mnopqr456')
  publicKey: 'idGFZV-z1XWoXomlx'
};

// Template de variables pour EmailJS
// Assurez-vous que votre template EmailJS utilise ces noms de variables :
/*
Template variables à utiliser dans EmailJS :
- {{from_name}} : Nom de l'expéditeur
- {{from_email}} : Email de l'expéditeur  
- {{subject}} : Sujet du message
- {{message}} : Corps du message
- {{to_name}} : Votre nom (destinataire)
- {{to_email}} : Votre email (destinataire)
- {{reply_to}} : Email pour les réponses
*/
